var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangePasswordHighlighted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5913",
    "data-name": "Rectangle 5913",
    width: 24.186,
    height: 27.521,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Change_password-highlighted",
    "data-name": "Change password-highlighted",
    transform: "translate(-1591 -690)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21210",
    "data-name": "Group 21210",
    transform: "translate(-202 408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21152",
    "data-name": "Group 21152",
    transform: "translate(1793 282)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_896",
    "data-name": "Ellipse 896",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21209",
    "data-name": "Group 21209",
    transform: "translate(1601 695.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21208",
    "data-name": "Group 21208",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10029",
    "data-name": "Path 10029",
    d: "M3.369,7.714A21.511,21.511,0,0,1,3.391,4.7,5.44,5.44,0,0,1,9.213.014,5.523,5.523,0,0,1,14.3,5.463c.018.719,0,1.439,0,2.244.288,0,.538-.005.787,0a2.441,2.441,0,0,1,2.5,2.415c.042.977-1.022.986-1.24,1.179-.123.108-.966.289-1.125.375a7.36,7.36,0,0,0-2.782,1.973c-1.737,2.19-1.3,5.88,1.6,6.622-.265.526-.489,1-.748,1.462a.513.513,0,0,1-.364.236c-3.537.01-7.075.023-10.612-.008a2.36,2.36,0,0,1-2.3-2.327q-.04-4.791,0-9.582a2.4,2.4,0,0,1,2.3-2.335c.305-.016.612,0,1.046,0m8.717-.039c0-.78.018-1.532,0-2.282a3.267,3.267,0,0,0-3-3.177A3.2,3.2,0,0,0,5.647,4.643a21.091,21.091,0,0,0-.2,3.032Z",
    transform: "translate(0 0)",
    fill: "#505465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10030",
    "data-name": "Path 10030",
    d: "M89.06,108.7a8.37,8.37,0,1,1-8.367-8.6,8.487,8.487,0,0,1,8.367,8.6",
    transform: "translate(-64.874 -89.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10031",
    "data-name": "Path 10031",
    d: "M110.631,127.464c.188-.23.347-1.313.584-1.445.254-.141.582-.318.829-.224a.977.977,0,0,1,.508.7c.056.923-.268,2.258-.293,3.184a.745.745,0,0,1-.782.788c-.926.021-2.16.429-3.083.369a.784.784,0,0,1-.62-.47,1.241,1.241,0,0,1,.178-.876,10.315,10.315,0,0,1,1.469-.733c-1.684-1.21-4.4-1.052-5.507.447-.111.151-.2.318-.308.474-.357.528-1.105.895-1.493.662a1.087,1.087,0,0,1-.405-1.512,5.642,5.642,0,0,1,4.028-2.913c1.637-.311,3.442.546,4.895,1.554",
    transform: "translate(-91.088 -112.809)",
    fill: "#505465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10032",
    "data-name": "Path 10032",
    d: "M98.016,194.311c-.175.225-.319,1.087-.553,1.223a1.2,1.2,0,0,1-.884.159.947.947,0,0,1-.489-.7c-.058-.923.255-2.211.282-3.137a.783.783,0,0,1,.876-.807c.841-.014,1.944-.209,2.785-.217a.868.868,0,0,1,.925.5.854.854,0,0,1-.282,1.013c-.121.119-1.03.505-1.147.63,1.362,1.068,4.22.9,5.313-.646.1-.14.232-.306.33-.446a1.131,1.131,0,0,1,1.263-.513.935.935,0,0,1,.505,1.318,5.845,5.845,0,0,1-5.82,2.974,8.056,8.056,0,0,1-3.1-1.359",
    transform: "translate(-86.182 -171.171)",
    fill: "#505465"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordHighlighted);
export default __webpack_public_path__ + "static/media/ChangePassword-highlighted.e074a833ccca2e1f436c9f4cc46abfd9.svg";
export { ForwardRef as ReactComponent };